import React from 'react';

const SensorItemHoc =
  (Component, board) =>
  ({ binary, group }) => {
    return (
      <Component
        id={binary.id}
        name={binary?.name || ''}
        description={binary?.description || ''}
        company={binary?.company || ''}
        detailsPageUrl={`/${group}/${binary?.id}/${board}`}
        imageUrl={binary?.icon[group][board] || '#!'}
        PathToManifest={binary?.manifest[group] || '#!'}
        gitHubUrl={binary?.repository[board] || '#!'}
      />
    );
  };

export default SensorItemHoc;
